export interface Team {
  id: string;
  name: string;  // Localization key
  nameFeminine: string;  // Localization key for feminine version
  icon: 'gamepad' | 'sparkles' | 'trophy';
  colorIndex: 0 | 1 | 2;
}

export const teams: Team[] = [
  {
    id: 'team1',
    name: 'game.teams.innovators',
    nameFeminine: 'game.teams.innovatorsFeminine',
    icon: 'gamepad',
    colorIndex: 0
  },
  {
    id: 'team2',
    name: 'game.teams.creators',
    nameFeminine: 'game.teams.creatorsFeminine',
    icon: 'sparkles',
    colorIndex: 1
  },
  {
    id: 'team3',
    name: 'game.teams.champions',
    nameFeminine: 'game.teams.championsFeminine',
    icon: 'trophy',
    colorIndex: 2
  }
];
